import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { getRoutesOfType } from "../../../utils/helpers";
import { typeRoute } from "../../../utils/staticData";
import guid from './../../../utils/guid';
import SingleRoute from './SingleRoute';
import CurrentSingleRoute from './CurrentSingleRoute';

const Polylines = (props) => {
    const { selectedRoutes, driveFilter, currentRoute, isSelectedCurrentRoute} = props;
    const [visibleRoutes, setRoutes] = useState([]);
    const [currentVisibleRoute, setCurrentVisibleRoute] = useState([]);

    useEffect(() => {
        if (!selectedRoutes)
            return setRoutes([]);
        let routes = getRoutesOfType(selectedRoutes, typeRoute);
        routes = routes.filter(route => route.selected === true);
        setRoutes(routes);
    }, [selectedRoutes, driveFilter, currentRoute]);

    useEffect(() => {
        if(currentRoute){
            setCurrentVisibleRoute(currentRoute.data);
        }
    }, [ currentRoute]);

    const printRoutes = data => {
        if (data === null)
            return;
        if (!Array.isArray(data))
            data = [data];
        return data.map(route => {
            return (
                <SingleRoute
                    key={guid()}
                    route={route}
                    updateStartAddress={props.updateStartAddress}
                    updateEndAddress={props.updateEndAddress}
                />
            );
        });
    };

    const printCurrentRoute = data => {
        if (data === null || !isSelectedCurrentRoute)
            return;
        if (!Array.isArray(data))
            data = [data];
            return (
                <CurrentSingleRoute
                    key={guid()}
                    route={data}
                    //updateStartAddress={props.updateStartAddress}
                    //updateEndAddress={props.updateEndAddress}
                />
            );
    };

    return (
        <React.Fragment>
            {printRoutes(visibleRoutes)}
            {printCurrentRoute(currentVisibleRoute)}
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        currentRoute: state.mapRoutesReducer.currentRoute,
        isSelectedCurrentRoute: state.mapRoutesReducer.showCurrentRoute,
        routes: state.mapRoutesReducer.routes,
        driveFilter: state.filterReducer.drive,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Polylines);

Polylines.propTypes = {
    //redux
    selectedRoutes: PropTypes.array,
    currentRoute: PropTypes.object,
    isSelectedCurrentRoute: PropTypes.bool,
    fitInBounds: PropTypes.func.isRequired,
    updateStartAddress: PropTypes.func,
    updateEndAddress: PropTypes.func,
    driveFilter: PropTypes.bool,
};